export default __webpack_public_path__ + "static/media/social-youtube.fbc8fceb.svg";